import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderComponent } from './order/order.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { orderAssistantRoutes } from './order-assistant.router';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CardSelectorComponent } from './order/card-selector/card-selector.component';
import { HeaderComponent } from './order/header/header.component';
import { TotalCardHeaderComponent } from './tankkarte/total-card-header/total-card-header.component';
import { OrderService } from './services/order.service';
import { LibsModule } from '../libs.module';
import { PhoneInputComponent } from './order/phone-input/phone-input.component';
import { PaymentTypeSelectorComponent } from './order/payment-type-selector/payment-type-selector.component';
import { ViewDocsComponent } from './view-docs/view-docs.component';
import { OtherTemplatesService } from '../home/services/other-templates.service';
import { OrderCancellationComponent } from './order-cancellation/order-cancellation.component';
import { OrderCancellationConfirmationComponent } from './order-cancellation/order-cancellation-confirmation/order-cancellation-confirmation.component';
import { WebIdComponent } from './web-id/web-id.component';
import { SofortPaymentService } from './services/sofort-payment.service';
import {TitleCaseDirective} from '../directives/text-input/title-case.directive';
import {AddressCaseDirective} from '../directives/text-input/address-case.directive';
import { TankkarteComponent } from './tankkarte/tankkarte.component';
import { TotalPhoneInputComponent } from './tankkarte/total-phone-input/total-phone-input.component';
import {TotalCardOrderService} from './services/total-card-order.service';

import {InvoiceInfoService} from './services/invoice-info.service';

import {ChangePaymentUploadComponent} from './change-payment-upload/change-payment-upload.component';
import {PaymentUploadSuccessComponent} from './payment-upload-success/payment-upload-success.component';
import {PaymentTypeSelectorListComponent} from './order/payment-type-selector-list/payment-type-selector-list.component';
import {SmsVerificationComponent} from './sms-verification/sms-verification.component';
import {ChangePaymentComponent} from './change-payment/change-payment.component';
import {ChangeEmailConfirmationComponent} from './change-email-confirmation/change-email-confirmation.component';
import { OnfidoComponent } from './onfido/onfido.component';
import {IdentComponent} from './ident/ident.component';
import { VerificationCompleteComponent } from './verification-complete/verification-complete.component';
import { OrderSummaryComponent } from './order/order-summary/order-summary.component';
import { OrderSummaryLinkpageComponent } from './order-summary-linkpage/order-summary-linkpage.component';
import { ReferralComponent } from './referral/referral/referral.component';
import { GetAppComponent } from './get-app/get-app.component';
import {QRCodeModule} from 'angular2-qrcode';
import { FxRateComponent } from './fx-rate/fx-rate.component';
import { AccountDeletionComponent } from './account-deletion/account-deletion.component';
import { AccountDeletionConfirmationComponent } from './account-deletion/account-deletion-confirmation/account-deletion-confirmation.component';
import {BrandReferralComponent} from "./referral/brand-referral/brand-referral.component";
import {OpenInAppComponentComponent} from "../open-in-app-component/open-in-app-component.component";
import {CustomerActionComponent} from "./customer-action/customer-action.component";


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, '../../assets/i18n/', '.json');
}

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        RouterModule.forChild(orderAssistantRoutes),
        LibsModule,
      QRCodeModule
        //NgxStripeModule,
    ],
    declarations: [
        SmsVerificationComponent,
        ChangePaymentComponent,
        OrderComponent,
      ChangeEmailConfirmationComponent,
        CardSelectorComponent,
        HeaderComponent,
        PhoneInputComponent,
        TotalPhoneInputComponent,
        PaymentTypeSelectorComponent,
        ViewDocsComponent,
        OrderCancellationComponent,
        OrderCancellationConfirmationComponent,
        WebIdComponent,
        TitleCaseDirective,
        AddressCaseDirective,
        TankkarteComponent,
        TotalCardHeaderComponent,

        SmsVerificationComponent,
        ChangePaymentUploadComponent,
      PaymentUploadSuccessComponent,
      PaymentTypeSelectorListComponent,
      OnfidoComponent,
      IdentComponent,
      VerificationCompleteComponent,
      OrderSummaryComponent,
      OrderSummaryLinkpageComponent,
      ReferralComponent,
      BrandReferralComponent,
      GetAppComponent,
      OpenInAppComponentComponent,
      CustomerActionComponent,
      FxRateComponent,
      AccountDeletionComponent,
      AccountDeletionConfirmationComponent
    ],
  entryComponents: [

  ],
  providers: [
    OrderService,
    TotalCardOrderService,
    OtherTemplatesService,
    SofortPaymentService,
    InvoiceInfoService
  ]
})
export class OrderAssistantModule { }
